import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Alarm({
  color = 'icon.conflictRed',
  fill = 'transparent',
  strokeWidth = 1.54545,
  ...props
}) {
  return (
    <IconBase viewBox='0 0 20 20' {...props}>
      <Path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M10 1V1C14.9712 1 19 5.0288 19 10V10C19 14.9712 14.9712
           19 10 19V19C5.0288 19 1 14.9712 1 10V10C1 5.0288 5.0288
            1 10 1Z'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M10.0083 10.4991V5.5'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M10.007 14.0551C9.8967 14.0551 9.80765 14.1441 9.80898
           14.2544C9.80898 14.3648 9.89803 14.4538 10.0084
            14.4538C10.1187 14.4538 10.2077 14.3648 10.2077 14.2544C10.2077 14.1454 10.1187 14.0551 10.007 14.0551'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Alarm.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.number,
}

export default Alarm
